// Driver fiscale RCH Print!F (Print!F3 RT e compatibili) — protocollo nativo a comandi via TCP/socket
import { lineTotal } from "@/lib/escpos";

// Mappa metodi VELTA → tender RCH (T1..T6, configurabili sul registratore)
const TENDER = {
  cash: 1,        // T1 Contanti
  assegno: 2,     // T2 Assegni
  card: 3,        // T3 Carta di credito / elettronico
  bonifico: 3,
  ticket: 4,      // T4 Ticket / buoni pasto
  non_riscosso: 5, // T5 Non riscosso / credito
  omaggio: 6,     // T6 Omaggio / sconto a pagare
};

const cents = (n) => Math.round(Number(n || 0) * 100);
const clean = (s) => String(s || "").replace(/[()\/$*=]/g, " ").slice(0, 24);

export const rchPrintFDriver = {
  id: "rch_printf",
  label: "RCH Print!F (F3 RT)",
  transport: "tcp",

  buildReceipt: ({ order = {}, payments = [] }) => {
    const cmds = [];
    cmds.push("=C1"); // operatore 1
    cmds.push("=K");  // annulla eventuale transazione pendente
    (order.lines || []).forEach((l) => {
      // Vendita reparto 1: =R<reparto>/$<prezzo unitario in centesimi>/*<qta>/(<descrizione>)
      cmds.push(`=R1/$${cents(l.price)}/*${l.qty}/(${clean(l.name)})`);
      const gross = l.price * l.qty;
      const net = lineTotal(l);
      if (net < gross - 0.001) {
        // Sconto a valore sull'ultima vendita
        cmds.push(`=V/$${cents(gross - net)}/(SCONTO)`);
      }
    });
    const pct = Number(order.discount_pct || 0);
    const eurD = Number(order.discount_eur || 0);
    if (pct > 0 || eurD > 0) {
      cmds.push("=S"); // subtotale
      const grossSum = (order.lines || []).reduce((s, l) => s + lineTotal(l), 0);
      const totalDisc = grossSum * (pct / 100) + Math.min(eurD, grossSum * (1 - pct / 100));
      if (totalDisc > 0.004) cmds.push(`=V/$${cents(totalDisc)}/(SCONTO)`);
    }
    // Chiusura: un comando tender per ogni metodo di pagamento
    payments.forEach((p) => {
      cmds.push(`=T${TENDER[p.method] || 1}/$${cents(p.amount)}`);
    });
    cmds.push("=c"); // fine transazione
    return cmds.join("\x0d\x0a") + "\x0d\x0a";
  },
};
